import {BaseClient} from "../../baseclient";
import {WasmExtension} from "../wasm";
import {SbtQueryExtension, SbtQueryExtensionMethods} from "./query";
import {SbtTxExtension, SbtTxExtensionMethods} from "./tx";

export type SbtExtension = SbtQueryExtension & SbtTxExtension;
export type SbtExtensionMethods = SbtQueryExtensionMethods & SbtTxExtensionMethods;

export function SbtExtension<T extends {new (...args: any[]): BaseClient & SbtExtension & WasmExtension}>(constructor: T): T {
  return class extends SbtQueryExtension(SbtTxExtension(constructor)) {};
}

export * from "./amino";
export * from "./query";
export * from "./tx";
